<template>
    <el-drawer :modal="false" 
        :visible.sync="drawerViewHubTeamDetails"
        class="drawer-hub-team-details"
        size="45%"
    >
        <div slot="title" class="d-flex align-items-center" @click="modals.show_edit_hub = true" style="cursor: pointer" v-if="current_hub">
            <span>{{ current_hub.hub_name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2 text-primary"><path fill="currentColor" d="m19.3 8.925-4.25-4.2 1.4-1.4q.575-.575 1.413-.575t1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387L19.3 8.925ZM17.85 10.4 7.25 21H3v-4.25l10.6-10.6 4.25 4.25Z"/></svg>
        </div>
        <b-container>
            <b-link @click="addTeam" :disabled="teamCount === 5">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6h-2Z"/></svg>
                    Add Team
            </b-link>
            
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form role="form" v-for="(team, index) in teams" :key="index">
                    <b-row class="mt-4">
                        <b-col cols="12">
                            <b-form-group>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamName'"
                                >
                                    <div slot="label">
                                        Team Name
                                        <b-link class="text-danger float-right" @click="deleteTeam(team, index)">Delete</b-link>
                                    </div>
                                    <b-form-input
                                    v-model="team.hub_team_name"
                                    placeholder="Enter Team Name"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Team Leader">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamLeader'"
                                >
                                    <!-- to show the selected team leader as well, use selectedteamleader function -->
                                    <el-select v-model="team.team_leader.id" filterable placeholder="Select Team Leader">
                                        <el-option
                                            v-for="option in selectedTeamLeaderOptions"
                                            :key="index + '-' + option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        ></el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group> 
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Team Members">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamMembers'"
                                >
                                    <!-- change v-model to only show team_member_ids only 
                                    addded new team_member_ids in resource api
                                    -->
                                    <el-select
                                        @visible-change="getEditHubTeamMemberList(team.hub_team_id)"
                                        v-model="team.team_member_ids"
                                        multiple
                                        filterable
                                        placeholder="Please enter a keyword">
                                        <el-option v-for="option in selectedTeamMemberOptions"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                        </el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="ml-auto text-right">
                            <!-- <b-button type="button" class="w-25" variant="primary" @click="updateHubTeams(team.hub_team_id, index)"  :disabled="invalid">Save</b-button> -->
                        </b-col>
                    </b-row>
                </b-form>
                <b-col cols="12" class="ml-auto text-right">
                    <b-button type="button" class="w-25" variant="primary" @click="updateHubTeams()"  :disabled="invalid">Save</b-button>
                </b-col>
            </ValidationObserver>
        </b-container>

        <EditHubDetailsModal :show_edit_hub.sync="modals.show_edit_hub"/>
    </el-drawer>
</template>
<script>
import { Drawer, Option, Select } from 'element-ui'
import EditHubDetailsModal from '@/views/Commission/Hub/HubProfile/HubModals/EditHubDetailsModal'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
import { mapState } from 'pinia'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js';
import { useHubStore } from '@/stores/hubStore'

export default {
    mixins: [notifyFunctionMixin],
    components: {
        EditHubDetailsModal,
        ValidationObserver,
        ValidationProvider,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    data() {
        return {
            drawerViewHubTeamDetails: false,
            modals:{
                show_edit_hub: false
            },
            teams: [],
            teamCount: 1,
            defaultTeamLeader: 28,
            selectTeamLeaderOptions: [],
            selectTeamMemberOptions: [],
            selectedTeamLeaderOptions: [],
            selectedTeamMemberOptions: []
        }
    },
    async created() {
        this.$watch(
            'current_hub',
            (newVal, oldVal) => {
                if (newVal) {
                    this.teams = newVal.hub_teams
                    this.teamCount = newVal.team_counts
                    this.teams.forEach(team => {
                        // this.getEditHubSaleManagerList(team.hub_team_id)
                        this.getEditHubTeamMemberList(team.hub_team_id)
                    })
                }
            }
        );

    },
    computed: {
        ...mapState(useHubStore,['current_hub']),
    },
    methods: {
        async viewHubTeamDetails() {
            this.drawerViewHubTeamDetails = !this.drawerViewHubTeamDetails;
            await this.setDefaulTeamLeader();
            await this.teamMembersList();
        },
        async setDefaulTeamLeader() {
            axios.get(services.hub + 'get_create_hub_team_user_options_list/' + this.$route.params.hub_id + '/leader', { headers: getHeader() })
            .then(response => {
                this.selectTeamLeaderOptions = response.data.data
                this.selectedTeamLeaderOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        async teamMembersList() {
            axios.get(services.hub + 'get_create_hub_team_user_options_list/' + this.$route.params.hub_id + '/member', { headers: getHeader() })
            .then(response => {
                this.selectTeamMemberOptions = [...response.data.data]
                this.selectedTeamMemberOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
            });
        },
        getEditHubSaleManagerList(hub_team_id) {
            const selected_team_leaders = this.teams.map(item => {
                if(hub_team_id != item.hub_team_id)
                {
                    return item.team_leader.id
                }
            }).filter(item => item != undefined);

            let team_leader_ids_options = this.selectTeamLeaderOptions;
            this.selectedTeamLeaderOptions = team_leader_ids_options.filter(item => !selected_team_leaders.includes(item.id));
        },
        getEditHubTeamMemberList(hub_team_id) {
            const selected_team_members = [].concat(
                ...this.teams.map(item => {
                    if(hub_team_id != item.hub_team_id)
                    {
                        return item.team_member_ids
                    }
                }).filter(item => item != undefined)
            );

            let team_member_ids_options = this.selectTeamMemberOptions;
            this.selectedTeamMemberOptions = team_member_ids_options.filter(item => !selected_team_members.includes(item.id));

            // axios.get(services.hub + 'get_edit_hub_team_user_options_list/member/' + hub_team_id, { headers: getHeader() })
            // .then(response => {
            //     // use hub team id for prevent javascript auto random re-arrange problem
            //     this.selectedTeamMemberOptions[hub_team_id] = response.data.data;
            //     this.$forceUpdate();
            // })
            // .catch ( error => {
            //     this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
            // });
        },
        addTeam() {
            if (this.teamCount < 5) {
                this.teamCount++

                // setting default team leader
                const selected_team_leaders = this.teams.map(item => item.team_leader.id);

                let defaultTeamLeader = this.selectTeamLeaderOptions.filter(item => !selected_team_leaders.includes(item.id));
                if(defaultTeamLeader.length > 0)
                {
                    this.defaultTeamLeader = defaultTeamLeader[0].id;
                }
                
                const postData = {
                    hub_id: this.$route.params.hub_id,
                    user_id: this.defaultTeamLeader // default user id
                }

                // create default empty hub team, together with team leader option list
                axios.post(services.hub + 'hub_team', postData ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {                        
                        this.teams.push({
                            name: '',
                            hub_team_id: response.data.data.hub_team_id,
                            team_leader: {
                                id: this.defaultTeamLeader,
                                name: ''
                            },
                            // members: [],
                        })

                        // this.getEditHubSaleManagerList(response.data.data.hub_team_id)
                        this.getEditHubTeamMemberList(response.data.data.hub_team_id)

                        this.$notify({
                            message:
                            '<b>New Hub Sale Team </b> - Successfully Created.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        this.$forceUpdate();
                        
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Create Hub Sale Team Failed")
                })
            }
        },
        deleteTeam(hub_team, index) {
            swal.fire({
                title: 'Are you sure?',
                text: 'You will delete Sale Team - ' + hub_team.team_leader.name,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.delete(services.hub + 'hub_team/' + hub_team.hub_team_id,{ headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                    '<b>Hub Sale Team : ' + hub_team.team_leader.name + '</b> - Successfully Deleted.',
                                timeout: 10000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });

                            if (this.teamCount > 0) {
                                this.teams.splice(index, 1)
                                this.teamCount--
                            }
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Delete Hub Team")
                    });
                } 
            })
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.selectTeamMemberOptions.name = this.list.filter(item => {
                    return item.label.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.selectTeamMemberOptions.name = [];
            }
        },
        // update hub team details, leader, and hub team name
        updateHubTeams(hub_team_id, index) {
            // check whether the team leader is being selected or not, before proceed to save function
            if(!this.teams[index].team_leader.id)
            {
                this.redErrorNotify( '<b>Invalid Input : Team Leader is Mandatory </b>')
            }
            else 
            {
                const postData = {
                    hub_id: this.$route.params.hub_id,
                    hub_team_name: this.teams[index].hub_team_name,
                    user_id: this.teams[index].team_leader.id,
                }
                const str = JSON.stringify(postData);

                axios.put(services.hub + 'hub_team/' + hub_team_id, postData ,{ headers: getHeader() })
                .then ( response =>  {
                    if (response.status === 200)
                    {
                        this.$notify({
                            message:
                            '<b>Hub Sale Team - ' + response.data.data.team_leader.name + ' </b> - Successfully Updated.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        // if success updated hub team, then only update hub team members
                        this.createHubTeamMemberData(hub_team_id, index);
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Update Hub Sale Team Failed")
                });
            }
        },
        updateHubTeams() {
            this.teams.forEach((item, index) => {
                // console.log('team',item);
                let postData = {
                    hub_id: this.$route.params.hub_id,
                    hub_team_name: item.hub_team_name,
                    user_id: item.team_leader.id,
                };

                axios.put(services.hub + 'hub_team/' + item.hub_team_id, postData ,{ headers: getHeader() })
                .then ( response =>  {
                    if (response.status === 200)
                    {
                        // this.$notify({
                        //     message:
                        //     '<b>Hub Sale Team - ' + response.data.data.team_leader.name + ' </b> - Successfully Updated.',
                        //     timeout: 10000,
                        //     icon: 'ni ni-bell-55',
                        //     type: 'default',
                        // });
                        // if success updated hub team, then only update hub team members
                        this.createHubTeamMemberData(item.hub_team_id, index);
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Update Hub Sale Team Failed")
                });
            })
        },
        createHubTeamMemberData(hub_team_id, index) {
            const postData = {
                hub_id: this.$route.params.hub_id,
                hub_team_id: hub_team_id,
                member_id: this.teams[index].team_member_ids,
            }

            axios.post(services.hub + 'hub_team_member', postData, { headers: getHeader() })
            .then(response => {
                // this.$notify({
                //     message:
                //     '<b>Hub Sale Team Member </b> - Successfully Updated.',
                //     timeout: 10000,
                //     icon: 'ni ni-bell-55',
                //     type: 'default',
                // });
                this.$notify({
                    message:
                    '<b>Hub Sale Team - ' + response.data.data[0].hub_team.team_leader.name + ' </b> - Successfully Updated.',
                    timeout: 10000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                });
            })
            .catch( error => {
                this.errorFunction(error, "Insert Hub Team Member Failed")
            });
            
        },
        // try to filter out the current select team leader from other team option lists
        handleSelectClick() {
            console.log('fndjaso');
        },
    }
}
</script>